import { atom } from "recoil";

export interface LoginBlockModalState {
  open: boolean;
  title: string;
  subtitle: string;
}

export const loginBlockModalAtom = atom<LoginBlockModalState>({
  key: "loginBlockModal",
  default: {
    open: false,
    title: "",
    subtitle: "",
  },
});
